"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.baseStatePropTypes = exports.ALIGN_RIGHT = exports.ALIGN_LEFT = exports.ALIGN_CENTER = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var ALIGN_LEFT = 'left';
exports.ALIGN_LEFT = ALIGN_LEFT;
var ALIGN_CENTER = 'center';
exports.ALIGN_CENTER = ALIGN_CENTER;
var ALIGN_RIGHT = 'right';
exports.ALIGN_RIGHT = ALIGN_RIGHT;
var baseStatePropTypes = {
  icon: _propTypes.default.string,
  icons: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string.isRequired,
    color: _propTypes.default.string,
    className: _propTypes.default.string
  })),
  image: _propTypes.default.node,
  headline: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  message: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  buttons: _propTypes.default.arrayOf(_propTypes.default.shape({
    text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
    className: _propTypes.default.string,
    onClick: _propTypes.default.func,
    href: _propTypes.default.string
  })),
  fullWidth: _propTypes.default.bool,
  condensed: _propTypes.default.bool,
  alignment: _propTypes.default.oneOf([ALIGN_LEFT, ALIGN_CENTER, ALIGN_RIGHT]),
  outerClassName: _propTypes.default.string,
  innerClassName: _propTypes.default.string
};
exports.baseStatePropTypes = baseStatePropTypes;